<template>
  <div
    v-tooltip="tooltip"
    class="system-communications-email-item"
    @click="emitClick"
  >
    <div class="system-communications-email-item-img">
      <img
        v-if="type === 'welcome'"
        class="system-communications-email-item-img-src"
        src="@assets/images/WelcomeEmail.png"
        :alt="type"
      />
      <img
        v-else
        class="system-communications-email-item-img-src"
        src="@assets/images/RecoveryEmail.webp"
        :alt="type"
      />
    </div>

    <p class="system-communications-email-item-title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      required: true,
    },
  },

  components: {},

  computed: {
    title() {
      return this.type === "welcome"
        ? this.$t("message.email.message.systemCommunicationsEmailWelcomeTitle")
        : this.$t("message.email.message.systemCommunicationsEmailRecoveryTitle");
    },
  },

  mounted() {},

  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.system-communications-email-item {
  border-radius: 20px;
  width: 350px;

  .system-communications-email-item-img {
    position: relative;
    background: #f2f2f2;
    border-radius: 20px 20px 0 0;
    border: 1px solid #c2c2c2;
    height: 300px;
    overflow: hidden;

    .system-communications-email-item-img-src {
      width: 100%;
      border-radius: 20px;
      border: 2px solid transparent;
      min-height: 100%;
    }
  }

  .system-communications-email-item-title {
    text-align: center;
    margin: 0;
    color: #707070;
    font-size: 18px;
    padding: 30px 0 10px;
    margin-top: -20px;
    border-left: 1px solid #c2c2c2;
    border-bottom: 1px solid #c2c2c2;
    border-right: 1px solid #c2c2c2;
    border-radius: 0 0 20px 20px;
  }

  .system-communications-email-item-img {
    filter: grayscale(1);

    &:hover {
      overflow: visible;
      cursor: pointer;
      border-radius: 20px;
      border-color: transparent;
      z-index: 1;

      .system-communications-email-item-img-src {
        border: 2px solid $green-dark;
      }
    }
  }
}
</style>
